import styled from 'styled-components';
import { Text16Regular } from '../../utils/Text/Text.styles';

export const Footer = styled.div`
  padding: 1.2rem 2.4rem 0 2.4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonWrapper = styled.div`
  display: flex;
`;

export const CloseButton = styled.button`
  border-radius: 16px;
  background: #f5f5f5;
  width: 17rem;
  height: 4.6rem;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ba1619;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.42px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-inline: -2.4rem;

  @media only screen and (max-width: 500px) {
    width: 100%;
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50rem;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 50rem;
  overflow: auto;
`;

export const ListItem = styled.div`
  padding: 1.6rem 3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f3f4f6;
  gap: 0.4rem;
  cursor: pointer;
  background: ${({ $selected }) => ($selected ? '#EEF5FD' : 'transparent')};
  opacity: ${({ $disabled }) => $disabled && '0.1'};
`;

export const ListItemRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

export const ListItemColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const MediaCountRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const MediaCountText = styled(Text16Regular)`
  color: #6c737f;
`;
